export default "__VITE_ASSET__HBpsAxgc__"